import {http} from "@/plugins/http";
import {Loan} from "@/model/loan";
import {BalancesDto, TransactionBalancesDto} from "@/model/balance";

export const supportService = new class SupportService {

  get path (): string {
    return '/support'
  }

  async getLoan (msisdn: string,region: number): Promise<Loan> {
    return (await http.get(this.path + '/get-loan', {
      params: {
        region: region,
        msisdn: msisdn
      }
    })).data
  }

  async getBalances (msisdn: string): Promise<BalancesDto> {
    return (await http.get(this.path + '/balances', {
      params: {
        msisdn: msisdn
      }
    })).data
  }

  async getBalancesForTransaction (transactionId: string): Promise<TransactionBalancesDto> {
    return (await http.get(this.path + '/transaction/balances?', {
      params: {
        transactionId: transactionId
      }
    })).data
  }
}
